import React, { useState, useEffect } from "react";
import axios from "axios";
import Room from "../components/Room";
import Loader from "../components/Loader";
import moment from "moment";
import "antd/dist/antd";
import { DatePicker } from "antd";
import AOS from "aos";
import "aos/dist/aos.css";

import Hero from "../components/Hero";
import TitleTwo from "../components/TitleTwo";
import Imagenineteen from "../images/comfort.jpg";
import Imagetwenty from "../images/aromas.jpg";

AOS.init({
  duration: 2000,
});

const { RangePicker } = DatePicker;

function Homescreen() {
  const SliderDataFour = [
    {
      title: "You will fall in love with ALL six rooms!",
      titletwo: "each one with new amenities and fully renovated",
      image: "https://i.postimg.cc/0y2NbZQL/IMG-7134.jpg",
      alt: "Lodge",
    },
    {
      title: "Your comfort is our TOP priority!",
      titletwo: "We invite you to experience luxury like never before!",
      image: Imagenineteen,
      alt: "Lodge",
    },
    {
      title: "Fresh coffee aromas travel through the mountian air",
      titletwo: "every morning at Little Heaven",
      image: Imagetwenty,
      alt: "Lodge",
    },
  ];

  const [rooms, setrooms] = useState([]);
  const [loading, setloading] = useState();
  const [error, seterror] = useState();
  
  const [duplicaterooms, setduplicaterooms] = useState([]);
  const [bookedrooms, setbookedrooms] = useState([]);
  const [availablesearchrooms, setavailablesearchrooms] = useState([]);
  const [availableresults, setavailableresults] = useState([]);
  const [kingrooms, setkingrooms] = useState([]);
  const [queenrooms, setqueenrooms] = useState([]);

  var [searchkey, setsearchkey] = useState("");
  const [present, setpresent] = useState(false);
  const [type, settype] = useState("All");

  var temprooms = [];
  var days = [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        localStorage.clear();
        setloading(true);
        const data = (await axios.get("/api/rooms/getallrooms")).data;
        setrooms(data);
        setduplicaterooms(data);
        setloading(false);
      } catch (error) {
        seterror(true);
        setloading(false);
      }
      setTimeout(() => {
        setloading(false);
      }, 1500);
    };
    fetchData().catch(console.error);
  }, []);

  function filterBySearch() {
    var newtemprooms = rooms.filter((room) =>
      room.descriptiontwo.toLowerCase().includes(searchkey.toLowerCase())
    );

    newtemprooms.forEach((room) => {
      temprooms.push(room);
    });

    setrooms(temprooms);

    if (searchkey.length === 0) {
      setrooms(duplicaterooms);
      searchkey = "";
      setpresent(false);
    } else {
      setrooms(temprooms);
      setavailableresults(temprooms);
      setpresent(true);
    }
  }

  function filterByType(e) {
    if (present === true) {
      if (e === "King Bed") {
        settype(e);

        var newtemprooms = availableresults.filter(
          (room) => room.type.toLowerCase() === e.toLowerCase()
        );

        newtemprooms.forEach((item) => {
          kingrooms.push(item);
        });
        setrooms(kingrooms);
      } else if (e === "Queen Bed") {
        settype(e);

        var newrooms = availableresults.filter(
          (room) => room.type.toLowerCase() === e.toLowerCase()
        );

        newrooms.forEach((item) => {
          queenrooms.push(item);
        });
        setrooms(queenrooms);
      } else if (e === "All") {
        settype(e);
        setrooms(availableresults);
      }
    }
    if (present === false) {
      if (e === "King Bed") {
        settype(e);

        var secondnewtemprooms = availablesearchrooms.filter(
          (room) => room.type.toLowerCase() === e.toLowerCase()
        );

        secondnewtemprooms.forEach((item) => {
          kingrooms.push(item);
        });
        setrooms(kingrooms);
      } else if (e === "Queen Bed") {
        settype(e);

        var secondnewrooms = availablesearchrooms.filter(
          (room) => room.type.toLowerCase() === e.toLowerCase()
        );

        secondnewrooms.forEach((item) => {
          queenrooms.push(item);
        });
        setrooms(queenrooms);
      } else if (e === "All") {
        settype(e);
        setrooms(availableresults);
      }
    }
    setkingrooms([]);
    setqueenrooms([]);
  }

  const modernStyles = `
    .modern-container {
      min-height: 100vh;
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .modern-hero-wrapper {
      margin-bottom: 0;
    }

    .modern-title-section {
      padding: 80px 20px;
      background: white;
      margin: 0;
    }

    .modern-title {
      max-width: 1200px;
      margin: 0 auto;
      text-align: center;
    }

    .modern-title h1 {
      font-size: clamp(2.5rem, 5vw, 4rem);
      font-weight: 300;
      color: #1e293b;
      margin-bottom: 2rem;
      letter-spacing: -0.02em;
      line-height: 1.1;
    }

    .modern-title-divider {
      width: 80px;
      height: 3px;
      background: linear-gradient(90deg, #d97706, #ea580c);
      margin: 2rem auto;
      border-radius: 2px;
    }

    .modern-title p {
      font-size: 1.125rem;
      line-height: 1.8;
      color: #64748b;
      max-width: 800px;
      margin: 0 auto;
      font-weight: 400;
    }

    .modern-search-section {
      padding: 60px 20px;
      background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    }

    .modern-search-container {
      max-width: 1200px;
      margin: 0 auto;
    }

    .modern-search-card {
      background: white;
      padding: 40px;
      border-radius: 24px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      border: 1px solid rgba(226, 232, 240, 0.8);
    }

    .modern-search-title {
      text-align: center;
      margin-bottom: 2rem;
      font-size: 1.5rem;
      font-weight: 600;
      color: #1e293b;
    }

    .modern-search-form {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      align-items: center;
    }

    @media (min-width: 768px) {
      .modern-search-form {
        flex-direction: row;
        justify-content: center;
      }
    }

    .modern-input-group {
      position: relative;
      flex: 1;
      max-width: 400px;
      width: 100%;
    }

    .modern-input {
      width: 100%;
      padding: 16px 20px;
      border: 2px solid #e2e8f0;
      border-radius: 16px;
      font-size: 1rem;
      transition: all 0.3s ease;
      background: #f8fafc;
      color: #1e293b;
      font-weight: 500;
    }

    .modern-input:focus {
      outline: none;
      border-color: #d97706;
      background: white;
      box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.1);
    }

    .modern-input::placeholder {
      color: #94a3b8;
      font-weight: 400;
    }

    .modern-select {
      padding: 16px 20px;
      border: 2px solid #e2e8f0;
      border-radius: 16px;
      font-size: 1rem;
      background: #f8fafc;
      color: #1e293b;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      min-width: 200px;
    }

    .modern-select:focus {
      outline: none;
      border-color: #d97706;
      background: white;
      box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.1);
    }

    .modern-rooms-section {
      padding: 60px 20px;
      max-width: 1600px;
      margin: 0 auto;
    }

    .modern-rooms-grid {
      display: grid;
      gap: 3rem;
      grid-template-columns: 1fr;
      justify-items: center;
    }

    .modern-room-card {
      max-width: 1200px;
      width: 100%;
      background: white;
      border-radius: 24px;
      overflow: hidden;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      transition: all 0.4s ease;
      border: 1px solid rgba(226, 232, 240, 0.8);
    }

    .modern-room-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
    }

    .modern-room-card img {
      width: 100% !important;
      height: 400px !important;
      object-fit: cover !important;
      transition: transform 0.4s ease !important;
    }

    .modern-room-card:hover img {
      transform: scale(1.05) !important;
    }

    .modern-room-card .card-img-top {
      height: 400px !important;
      object-fit: cover !important;
    }

    .loader-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 80px 20px;
    }

    .no-results {
      text-align: center;
      padding: 80px 20px;
      color: #64748b;
    }

    .no-results h3 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
      color: #475569;
    }

    .no-results p {
      font-size: 1.125rem;
      margin-bottom: 2rem;
    }

    .clear-filters-btn {
      padding: 12px 24px;
      background: linear-gradient(135deg, #d97706, #ea580c);
      color: white;
      border: none;
      border-radius: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .clear-filters-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px -5px rgba(217, 119, 6, 0.4);
    }
  `;

  return (
    <>
      <style>{modernStyles}</style>
      <div className="modern-container">
        <div className="modern-hero-wrapper">
          <Hero slides={SliderDataFour} />
        </div>

        <div className="modern-title-section">
          <div className="modern-title">
            <h1>Little Heaven Bed & Breakfast</h1>
            <div className="modern-title-divider"></div>
            <p>
              <i>Welcome</i> to Yadkin Valley Lodging

at <i>Little Heaven Bed and Breakfast.</i> <br/>

Experience rustic charm meets modern luxury in our <b>6 uniquely themed guest rooms</b> set across two levels. Each room offers a private, fully renovated ensuite bathroom, individual AC, cozy fireplace, HD TV, writing table, and top-of-the-line bedding designed for ultimate comfort. <br/>
<br/>

<h5>Stay Details & Amenities</h5> <br/>

 <b>Dining:</b> Delicious daily breakfast is included with your stay! Dinner can also be added for an extra fee, payable at the lodge upon checkout. <br/>

 <b>In-Room Comforts:</b> Plush robes, high-end toiletries (shampoo, body wash, hand soap), towels, iron, and ironing board. <br/>

 <b>Check-In:</b> 3:00 PM daily. Unless you opt in for the wine tour then we begin at 11AM. 

We can’t wait to welcome you to the Cabin!
            </p>
          </div>
        </div>

        <div className="modern-search-section">
          <div className="modern-search-container">
            <div className="modern-search-card" data-aos="fade-up">
              <h2 className="modern-search-title">Find Your Perfect Room</h2>
              
              <div className="modern-search-form">
                <div className="modern-input-group">
                  <input
                    type="text"
                    className="modern-input"
                    placeholder="Search rooms..."
                    value={searchkey}
                    onChange={(e) => {
                      setsearchkey(e.target.value);
                    }}
                    onKeyUp={filterBySearch}
                  />
                </div>

                {present === true && (
                  <select
                    className="modern-select"
                    value={type}
                    onChange={(e) => {
                      filterByType(e.target.value);
                    }}
                  >
                    <option value="All">All Room Types</option>
                    <option value="King Bed">King Bed</option>
                    <option value="Queen Bed">Queen Bed</option>
                  </select>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modern-rooms-section">
          {loading ? (
            <div className="loader-container">
              <Loader />
            </div>
          ) : rooms.length > 0 ? (
            <div className="modern-rooms-grid">
              {rooms.map((room) => {
                return (
                  <div
                    className="modern-room-card"
                    key={room.name}
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <Room
                      room={room}
                      rentPerDay2={room.rentPerDay2}
                      rentPerDay3={room.rentperDay3}
                      rentPerDay={room.rentPerDay}
                      key={room.name}
                      totalamount={room.totalamount}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-results">
              <h3>No rooms found</h3>
              <p>Try adjusting your search criteria</p>
              <button
                className="clear-filters-btn"
                onClick={() => {
                  setsearchkey("");
                  settype("All");
                  setpresent(false);
                  setrooms(duplicaterooms);
                }}
              >
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Homescreen;